<template>
  <div>
    <div class="right">
      <a-icon type="printer" @click="$print(id)" title="打印" />
      <a-icon type="download" @click="$download(id)" title="下载" />
    </div>
    <div :id="id"></div>
  </div>
</template>


<script>
import * as echarts from "echarts/core";
import { LineChart } from "echarts/charts";
import {
  TooltipComponent,
  GridComponent,
  LegendComponent,
} from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([
  LineChart,
  CanvasRenderer,
  TooltipComponent,
  GridComponent,
  LegendComponent,
]);
export default {
  props: {
    id: {
      type: String,
    },
    list: {
      type: Array,
      default: () => [],
    },
  },

  watch: {
    list() {
      this.renderChart();
    },
  },

  mounted() {
    var chartDom = document.getElementById(this.id);
    chartDom.style.height = "25vh";
    chartDom.style.width = "100%";
    this.chart = echarts.init(chartDom);
    this.renderChart();
  },

  methods: {
    renderChart() {
      var option = {
        xAxis: {
          type: "category",
          data:
            this.list.length > 0
              ? this.list.map((item) => item.category)
              : [1, 2, 3, 4, 5, 6, 7, 8],
          splitLine: {
            show: true,
          },
          axisLine: {
            show: true,
          },
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLine: {
            show: true,
          },
          axisLabel: {},
        },

        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },

        grid: {
          left: "12%",
          top: "10%",
          right: "3%",
          bottom: "15%",
        },

        series: [
          {
            name: "",
            type: "line",
            smooth: true,
            // data: this.list.map((item) => item.flowrate),
            data:
              this.list.length > 0
                ? this.list.map((item) => item.value)
                : [10, 20, 30, 20, 10, 5, 20, 30],
          },
        ],
      };

      option && this.chart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.right {
  gap: 0.5em;
  margin-right: 1em;
  cursor: pointer;
}
</style>